<div class="dialog-header flex align-items-center justify-content-between w-full">
  <h2>Generare raport lockere subutilizate</h2>
  <p-button
    mat-dialog-close
    size="small"
    icon="pi pi-times"
    severity="secondary"
    ariaLabel="Închide"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  <form [formGroup]="reportForm" class="grid">
    <div class="col-12 sm:col-6 sm:pr-3">
      <label class="font-bold block mb-2" for="low-activity-start-date">
        Dată început
      </label>
      <p-calendar
        styleClass="w-full"
        dateFormat="dd/mm/yy"
        inputId="low-activity-start-date"
        formControlName="startDate"
        appendTo="body"
        [showIcon]="true"
        [showTime]="true"
        [panelStyle]="{ 'height': '547px' }"
      ></p-calendar>
    </div>

    <div class="col-12 sm:col-6 sm:pl-3">
      <label class="font-bold block mb-2" for="low-activity-end-date">
        Dată sfârșit
      </label>
      <p-calendar
        styleClass="w-full"
        dateFormat="dd/mm/yy"
        inputId="low-activity-end-date"
        formControlName="endDate"
        appendTo="body"
        [showIcon]="true"
        [showTime]="true"
        [panelStyle]="{ 'height': '547px' }"
      ></p-calendar>
    </div>

    <div class="col-12">
      <label class="font-bold block mb-1" for="low-activity-zones">
        Zone
      </label>
      <p-treeSelect
        inputId="low-activity-zones"
        formControlName="zones"
        selectionMode="checkbox"
        class="block w-full"
        containerStyleClass="w-full"
        appendTo="body"
        placeholder="Selectează zone"
        [options]="zoneNodes()"
        [metaKeySelection]="false"
        [propagateSelectionDown]="false"
        [propagateSelectionUp]="false"
        [filter]="true"
        [loading]="loadingZones()"
      >
        <ng-template pTemplate="value" let-value>
          {{ zoneSelectionLabel(value) }}
        </ng-template>
      </p-treeSelect>
      <small class="block text-gray-500 mt-1">
        O zonă bifată include automat toate sub-zonele ei.
      </small>
      @let zonesField = reportForm.get('zones');
      @if (zonesField?.dirty && zonesField?.errors) {
        <small class="text-red-500">Vă rugăm să selectați minim o zonă</small>
      }
    </div>

    <div class="col-12 sm:col-6 sm:pr-3">
      <label class="font-bold block mb-2" for="low-activity-threshold">
        Prag (% din media zonei)
      </label>
      <p-inputNumber
        inputId="low-activity-threshold"
        formControlName="thresholdPercent"
        suffix=" %"
        styleClass="w-full"
        [min]="0"
        [max]="100"
        [showButtons]="true"
      ></p-inputNumber>
    </div>

    <div class="col-12 sm:col-6 sm:pl-3">
      <label class="font-bold block mb-2" for="low-activity-activity-types">
        Activitate
      </label>
      <p-multiSelect
        inputId="low-activity-activity-types"
        formControlName="activityTypes"
        class="block w-full"
        styleClass="w-full"
        appendTo="body"
        placeholder="Selectează activitate"
        selectedItemsLabel="{0} tipuri selectate"
        [maxSelectedLabels]="1"
        [options]="activityTypeOptions"
        [showToggleAll]="false"
      ></p-multiSelect>
      @let activityField = reportForm.get('activityTypes');
      @if (activityField?.dirty && activityField?.errors) {
        <small class="text-red-500">
          Selectați minim un tip de activitate
        </small>
      }
    </div>

    <div class="col-12 mt-2">
      <p-checkbox
        inputId="low-activity-dialog-include-all"
        label="Arată toate lockerele (cele sub prag sunt marcate)"
        formControlName="includeAll"
        [binary]="true"
      ></p-checkbox>
    </div>

    <div class="flex gap-2 col-12 mt-1 mb-1 align-items-center">
      <p class="m-0">Tipul raportului:</p>
      <p-checkbox label="PDF" value="PDF" formControlName="type"></p-checkbox>
      <p-checkbox label="Excel" value="XLSX" formControlName="type"></p-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex align-items-center gap-2">
    <button
      pButton
      size="small"
      data-testid="dialog-secondary"
      label="Renunță"
      [text]="true"
      mat-dialog-close
    ></button>
    <button
      pButton
      size="small"
      data-testid="dialog-primary"
      label="Generează raport"
      icon="pi pi-file-plus"
      iconPos="right"
      type="submit"
      (click)="generateReport()"
    ></button>
  </div>
</mat-dialog-actions>
@if (generating()) {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}
